import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import Session from "../utils/sessionStorage";
import axiosInstance from '../utils/axiosInstance';
import ErrorModal from '../components/ErrorModal';
import Button from '../components/form/Button';
import { useNavigate } from "react-router-dom";
import Prompt from '../components/Prompt';

const MNP = () => {
    const [donors, setDonors] = useState([]);
    const [selectedDonor, setSelectedDonor] = useState("");
    const [errorModal, setErrorModal] = useState({ open: false, message: "" });
    const result = Session.get("_user_");
    const userData = result ? JSON.parse(result) : "";
    const [sttdUserPrompt, setSttdUserPrompt] = useState(false);
    console.log("session user :", userData.customerType);
    const stduser = userData?.customerType;
    useEffect(() => {
        if (stduser === "StdCDD" || stduser === "FullCDD") {
            setSttdUserPrompt(true);
        }
    }, [stduser]);
    const token = Session.get("token");
    const navigate = useNavigate();
    useEffect(() => {
        async function getDonorList() {
            try {
                const response = await axiosInstance.get("api/v1/get-donor-list", {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.status === 200) {
                    setDonors(response.data.donor_list);
                }
            } catch (error) {
                setErrorModal({ open: true, message: error?.response?.data?.message || "Failed to load states" });
            }
        }
        getDonorList();
    }, [token]);

    const handleDonorChange = (e) => {
        setSelectedDonor(e.target.value);
    }

    const handleNext = () => {
        if (!selectedDonor) {
            setErrorModal({ open: true, message: "Please select a Current Network" });
            return;
        } else {
            navigate("/mnp-register", { state: { selectedDonor } })
        }
    }
    console.log("Donor States: ", donors);
    console.log("selected donor: ", selectedDonor)

    if (!sttdUserPrompt) {
        return <Prompt call={"onLink"} close={() => navigate('/home')} />
    }

    return (
        <div>
            <Header />
            <div className="max-w-md my-6 px-4 mx-auto bg-white rounded-lg ">
                <div>
                    <label className="block text-[13px] font-medium text-gray-700">Current Network <span className='text-red-500'>*</span></label>
                    <select
                        value={selectedDonor}
                        onChange={handleDonorChange}
                        className="font-poppins w-full p-3 text-[#1111117A] border-[1px] border-[#11111126] rounded-[8px] outline-none bg-transparent border-accent-silver-300 focus:ring-blue-500 focus:border-blue-500  placeholder:text-base placeholder:font-normal text-accent-silver-900 placeholder:text-accent-silver-900"
                    >
                        <option value="">Select Current Network</option>
                        {donors.map((donor, index) => (
                            <option key={index} value={donor.subdonor}>
                                {donor.subdonor}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="w-full my-14">
                    <Button classes={"w-full"} disable={!selectedDonor} size={"xxlg"} eventAction={handleNext}>
                        Next
                    </Button>
                </div>
            </div>

            {/* Error Modal */}
            {errorModal.open && (
                <ErrorModal
                    message={errorModal.message}
                    close={() => setErrorModal({ open: false, message: "" })}
                />
            )}
        </div>
    )
}

export default MNP
